import gql from 'graphql-tag'

export const CHECK_RESET_USER_PASSWORD_TOKEN_MUTATION = gql`
	mutation ($token: String!, $code: String!){
		checkResetUserPasswordToken(
			data: {
				token: $token
				code: $code
			}
		) {
			email
		}
	}
`;

export const CONFIRM_RESET_USER_PASSWORD_MUTATION = gql`
	mutation ($token: String!, $code: String!, $password: String!){
		confirmResetUserPassword(
			data: {
				token: $token
				code: $code
				password: $password
			}
		)
	}
`;

export const LOGIN_MUTATION = gql`
	mutation ($email: String!, $password: String!) {
		loginUser(
			data: {
				email: $email
				password: $password
			}
		) {
			accessToken
			refreshToken
			user {
				id
				firstName
				lastName
				shortFullName
				fullName
				telNumber
				email
				userGroupAlt
				image
				userGroup {
					alt
					privileges {
						alt
					}
				}
			}
		}
	}
`;

export const LOGOUT_MUTATION = gql`
	mutation ($refreshToken: String!){
		logoutUser(data: {
			refreshToken: $refreshToken
		})
	}
`;

export const REFRESH_TOKEN_MUTATION = gql`
	mutation ($refreshToken: String!){
		refreshUserToken(data: {
			token: $refreshToken
		}){
			accessToken
			refreshToken
			user {
				id
				email
				firstName
				lastName
			}
		}
	}
`;

export const RESET_USER_PASSWORD_MUTATION = gql`
	mutation ($email: String!){
		resetUserPassword(
			data: {
				email: $email
			}
		)
	}
`;
